import { render, staticRenderFns } from "./CollapseComponent.vue?vue&type=template&id=314f64c6&scoped=true"
import script from "./CollapseComponent.vue?vue&type=script&lang=js"
export * from "./CollapseComponent.vue?vue&type=script&lang=js"
import style0 from "./CollapseComponent.vue?vue&type=style&index=0&id=314f64c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314f64c6",
  null
  
)

export default component.exports